import { Link } from "react-router-dom";
import { AiOutlineFilePdf } from "react-icons/ai";
export const config = (withFilter) => [
  {
    name: "N° d'immatriculation",
    selector: (row) => (row.registration_number ? row.registration_number : row.first_registration_number + '/' + row.last_registration_number),
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Pays",
    selector: (row) => row.country?.name,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Motif",
    selector: (row) => row.motive,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Statut",
    sortable: true,
    filterable: withFilter,

    selector: (row) => row.status && row.status.title,
    conditionalCellStyles: [
      {
        when: (row) => row.status && row.status.type === "rejected",
        classNames: ["chip-component danger"],
      },
      {
        when: (row) => row.status && row.status.type === "validated",
        classNames: ["chip-component success"],
      },
      {
        when: (row) => row.status && row.status.type === "in_progress",
        classNames: ["chip-component warning"],
      },
      {
        when: (row) =>
          row.status && row.status.type === "additional_information",
        classNames: ["chip-component primary"],
      },
    ],
  },
  {
    name: "Date de création",
    selector: (row) => row.created_at,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Fichiers",
    selector: (row) => row.files && row.files,
    cell: (row) => (
      <>
        {row.files && (
          <Link to={row.files} target="_blank" download>
            <AiOutlineFilePdf />
          </Link>
        )}
      </>
    ),
  },
];
